(() => {
  const mq = window.matchMedia("(max-width: 749px)");

  function bind() {
    const blocks = document.querySelectorAll(
      ".footer .footer__blocks-wrapper.ig-footer-cols > .footer-block"
    );
    blocks.forEach((block) => {
      if (!block.querySelector("ul.footer-block__details-content")) return;

      const heading = block.querySelector(".footer-block__heading");
      if (!heading || heading.dataset.igAccordionBound === "1") return;
      heading.dataset.igAccordionBound = "1";
      heading.setAttribute("role", "button");
      heading.setAttribute("tabindex", "0");
      heading.setAttribute("aria-expanded", "false");

      const toggle = () => {
        if (!mq.matches) return;
        const open = block.classList.toggle("is-open");
        heading.setAttribute("aria-expanded", open ? "true" : "false");
      };

      heading.addEventListener("click", toggle);
      heading.addEventListener("keydown", (e) => {
        if (e.key === "Enter" || e.key === " ") {
          e.preventDefault();
          toggle();
        }
      });
    });
  }

  function resetDesktop() {
    if (mq.matches) return;
    document
      .querySelectorAll(
        ".footer .footer__blocks-wrapper.ig-footer-cols > .footer-block.is-open"
      )
      .forEach((block) => {
        block.classList.remove("is-open");
        const heading = block.querySelector(".footer-block__heading");
        if (heading) heading.setAttribute("aria-expanded", "false");
      });
  }

  const run = () => {
    bind();
    resetDesktop();
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", run);
  } else {
    run();
  }
  mq.addEventListener("change", resetDesktop);
})();
